<template>
  <footer class="footer-bg footer-p pt-90" style="background-color: #2C5C9E"> 
    <!-- Top Footer #001f3f-->
    <div class="footer-top pb-30">
      <div class="container">
        <div class="row justify-content-between">
          <!-- Column 1 -->
          <div class="col-xl-4 col-lg-4 col-sm-6">
            <div class="footer-widget mb-30">
              <div class="f-widget-title">
                <h2>
                  <img src="../assets/logo-white.png" alt="logo" />
                </h2>
              </div>
              <!-- <div class="f-contact">
                <ul>
                  <li>
                    <i class="icon fa-solid fa-phone"></i>
                    <span>
                      <a href="tel:+17802005410">+1 (780) 200-5410</a>
                    </span>
                  </li>
                  <li>
                    <i class="icon fa-solid fa-envelope"></i>
                    <span>
                      <a href="mailto:info@archvarsity.com"
                        >info@archvarsity.com</a
                      >
                    </span>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>

          <!-- Column 2 -->
          <div class="col-xl-2 col-lg-2 col-sm-6">
            <div class="footer-widget mb-30">
              <div class="f-widget-title">
                <h2>Our Links</h2>
              </div>
              <div class="footer-link">
                <ul>
                  <li>
                    <router-link
                      to="/"
                      @click.prevent="handleScrollToSection('home')"
                      >Home</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/"
                      @click.prevent="handleScrollToSection('about')"
                      >About Us</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/courses"
                      >Courses</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/for-mentors">For Mentors</router-link>
                  </li>
                  <li>
                    <router-link to="/financial-planning"
                      >Financial Planning</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/mission"
                      >Vision and Mission</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      to="/feedback"
                      >Sumbit Feedback</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Column 3 -->
          <div class="col-xl-2 col-lg-2 col-sm-6">
            <div class="footer-widget mb-30">
              <div class="f-widget-title">
                <h2>Categories</h2>
              </div>
              <div class="footer-link">
                <ul>
                  <li><router-link to="/">Leadership</router-link></li>
                  <li><router-link to="/">Business</router-link></li>
                  <li><router-link to="/">Education</router-link></li>
                  <li><router-link to="/">Law</router-link></li>
                  <li><router-link to="/">Finance</router-link></li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Column 4 -->
          <div class="col-xl-3 col-lg-3 col-sm-6">
            <div class="footer-widget mb-30">
              <div class="f-widget-title">
                <h2>Latest Courses</h2>
              </div>
              <div class="recent-blog-footer">
                <ul>
                  <li>
                    <div class="thum">
                      <img
                        src="../assets/img/blog/s-blogimg-01.png"
                        alt="post"
                      />
                    </div>
                    <div class="text">
                      <a href="/course-detail/67ceafcd5b46673c21170af5"
                        >The Lighthouse Leadership Program</a
                      >
                      <span
                        ><a href="/course-detail/67ceafcd5b46673c21170af5"
                          >View course details</a
                        ></span
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="copyright-wrap">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6">
            Copyright © Archvarsity 2025. All rights reserved.
          </div>
          <div class="col-lg-6 text-right text-xl-right">
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms-service">Terms Of Service</a></li>
              <!-- <li><a href="#">Legal</a></li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  methods: {
    handleScrollToSection(idName) {
      if (this.$route.path !== "/") {
        // Navigate to Home first
        this.$router.push("/").then(() => {
          // Wait for the page to load before scrolling
          this.$nextTick(() => {
            this.scrollToSection(idName);
          });
        });
      } else {
        // If already on Home, just scroll
        this.scrollToSection(idName);
      }
    },
    scrollToSection(sectionId) {
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Small delay to ensure the DOM is updated
    },
  },
};
</script>

<style scoped>
/* Add footer styles here if needed */
.footer-area {
}
</style>
